// import 'react-responsive-carousel/lib/styles/carousel.min.css'; 
// import { Carousel } from 'react-responsive-carousel';

// const Slider = () => {
//   return (
//     <div style={{ width: '100%', height: 'auto', margin: 'auto', position: 'relative' }} id='home'>
//       <Carousel
//         autoPlay
//         infiniteLoop
//         showThumbs={false}
//         showStatus={false}
//         interval={4000}
//         dynamicHeight={true}
//         transitionTime={1000}
//         stopOnHover={true}
//       >
//         <div>
//           <img
//             src="/images/banners1.png"
//             alt="Slide 1"
//             style={{
//               width: '100%',
//               height: 'auto',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
//               transition: 'all 0.3s ease',
//             }}
//           />
//         </div>
        
//         <div>
//           <img
//             src="/images/banners2.png"
//             alt="Slide 2"
//             style={{
//               width: '100%',
//               height: 'auto',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
//               transition: 'all 0.3s ease',
//             }}
//           />
//         </div>
//         <div>
//           <img
//             src="/images/banners3.png"
//             alt="Slide 3"
//             style={{
//               width: '100%',
//               height: 'auto',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
//               transition: 'all 0.3s ease',
//             }}
//           />
//         </div>
//         <div>
//           <img
//             src="/images/banners4.png"
//             alt="Slide 4"
//             style={{
//               width: '100%',
//               height: 'auto',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
//               transition: 'all 0.3s ease',
//             }}
//           />
//         </div>

//         <div>
//           <img
//             src="/images/banners5.png"
//             alt="Slide 5"
//             style={{
//               width: '100%',
//               height: 'auto',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
//               transition: 'all 0.3s ease',
//             }}
//           />
//         </div>
//         <div>
//           <img
//             src="/images/banner6.png"
//             alt="Slide 6"
//             style={{
//               width: '100%',
//               height: 'auto',
//               objectFit: 'cover',
//               borderRadius: '10px',
//               boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.3)',
//               transition: 'all 0.3s ease',
//             }}
//           />
//         </div>
        

//       </Carousel>
//     </div>
//   );
// };

// export default Slider;






//  import { Fade, Slide } from 'react-awesome-reveal';

// const Slider = () => {
//   return (
//     <div
//       id="home"
//       style={{
//         width: '100%',
//         height: '100vh',
//         overflow: 'hidden',
//         position: 'relative',
//       }}
//     >
//       {/* Video Background */}
//       <video
//         autoPlay
//         muted
//         loop
//         playsInline
//         preload="auto"
//         style={{
//           width: '100%',
//           height: '100%',
//           objectFit: 'cover',
//           filter: 'brightness(0.75)',
//         }}
//       >
//         <source src="/videos/banner clip2.mp4" type="video/mp4" />
//         Your browser does not support the video tag.
//       </video>

//       {/* Glass + Animated Text */}
//       <div
//         style={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           background: 'rgba(255, 255, 255, 0.1)',
//           backdropFilter: 'blur(10px)',
//           border: '1px solid rgba(255, 255, 255, 0.2)',
//           borderRadius: '20px',
//           padding: '40px 60px',
//           color: 'white',
//           textAlign: 'center',
//           zIndex: 2,
//         }}
//       >
//         <Slide direction="up" triggerOnce>
//           <h1
//             style={{
//               fontSize: '3.5rem',
//               fontWeight: 800,
//               background: 'linear-gradient(90deg, #00d4ff, #004cff)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent',
//               textShadow: '0 0 10px rgba(0, 212, 255, 0.6)',
//               marginBottom: '10px',
//             }}
//           >
//             SEPL INDUSTRIES
//           </h1>
//         </Slide>

//         <Fade delay={300} triggerOnce>
//           <p
//             style={{
//               fontSize: '1.3rem',
//               color: '#f1f1f1',
//             }}
//           >
//             Innovation | Engineering | Excellence
//           </p>
//         </Fade>
//       </div>
//     </div>
//   );
// };

// export default Slider;


import React, { useCallback, useEffect, useRef } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import gsap from 'gsap';
import SplitType from 'split-type';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../styles/Slider.css';

gsap.registerPlugin(ScrollTrigger);

const Slider = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadFull(engine);
  }, []);

  const textRef = useRef(null);

  useEffect(() => {
    const split = new SplitType(textRef.current, { types: 'chars' });

    gsap.from(split.chars, {
      scrollTrigger: {
        trigger: textRef.current,
        start: 'top 80%',
      },
      y: 100,
      opacity: 0,
      stagger: 0.05, // slower stagger
      duration: 2, // slower duration
      ease: 'power4.out',
      onComplete: () => {
        gsap.to(textRef.current, { opacity: 1, duration: 0.3 });
      },
    });
  }, []);

  return (
    <div id="home" className="slider-container">
      {/* Background Video */}
      <video autoPlay loop muted playsInline className="background-video">
        <source src="/videos/today_banner.mov" />
        Your browser does not support the video tag.
      </video>       

      {/* Dark Overlay */}
      <div className="dark-overlay"></div>

      {/* Particles */}
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          fullScreen: { enable: false },
          background: { color: 'transparent' },
          fpsLimit: 60,
          interactivity: {
            events: {
              onHover: { enable: true, mode: 'repulse' },
              resize: true,
            },
            modes: {
              repulse: { distance: 100, duration: 0.4 },
            },
          },
          particles: {
            color: { value: '#ffffff' },
            links: { enable: true, color: '#ffffff', distance: 150 },
            move: { enable: true, speed: 1 },
            number: { value: 40 },
            opacity: { value: 0.5 },
            shape: { type: 'circle' },
            size: { value: { min: 1, max: 3 } },
          },
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
        }}
      />

      {/* Animated Text */}
      <div className="text-overlay">
        <h1 ref={textRef} className="animated-title gradient-text">
          {/* Put your own text here */}
          {/* Transforming Your Vision Into Reality with SEPL */}
        </h1>
      </div>
    </div>
  );
};

export default Slider;
